export { bankAccountDetailsRoute } from './route'
